$(() => {
  $('#contributor-notification-modal').modal('show');
});
